// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__l3IH-","form":"styles_form__fPLqo"};